// ContactSearchDropdown.jsx
import React, { useState, useEffect } from "react";
import { TextField, Autocomplete, CircularProgress } from "@mui/material";
import axios from "axios";



const ContactSearchDropdown = ({ label, value, onSelect, companyId, fullWidth, disabled, searchField , connectionString}) => {
    const path = connectionString;
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [inputValue, setInputValue] = useState(value || "");

    // keep inputValue in sync if parent changes value
    useEffect(() => {
        setInputValue(value || "");
    }, [value]);

    // Fetch suggestions based on input
    const fetchSuggestions = async (searchTerm) => {
        if (!searchTerm || searchTerm.length < 1) {
            setOptions([]);
            return;
        }
        setLoading(true);
        try {
            const response = await axios.get(`${path}/api/contact-search`, { params: { search: searchTerm, companyId } });
            setOptions(response.data.data || []);
        } catch (error) {
            console.error(`Error fetching ${searchField} suggestions:`, error);
            setOptions([]);
        } finally {
            setLoading(false);
        }
    };

    // Debounce search to avoid excessive API calls
    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            fetchSuggestions(inputValue);
        }, 300);
        return () => clearTimeout(delayDebounceFn);
    }, [inputValue, companyId]);

    return (
        <Autocomplete
            freeSolo
            options={options}
            getOptionLabel={(option) =>
                typeof option === "string" ? option : option[searchField] || ""
            }
            // we keep `value` as a simple string (text shown). Autocomplete expects the "value"
            value={value || ""}
            onChange={(event, newValue) => {
                // selection from dropdown (object) or freeSolo string
                if (typeof newValue === "object" && newValue) {
                    // pass only the relevant fields (partial object)
                    onSelect({
                        ...(newValue.contactBy !== undefined ? { contactBy: newValue.contactBy } : {}),
                        ...(newValue.contactNumber !== undefined ? { contactNumber: newValue.contactNumber } : {}),
                    });
                } else {
                    // freeSolo selection (user pressed Enter or chose text)
                    onSelect(searchField === "contactBy" ? { contactBy: newValue || "" } : { contactNumber: newValue || "" });
                }
            }}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);

                // Immediately inform parent about typed value so parent state stays in sync
                if (searchField === "contactBy") {
                    onSelect({ contactBy: newInputValue || "" });
                } else {
                    onSelect({ contactNumber: newInputValue || "" });
                }
            }}
            disabled={disabled}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    fullWidth={fullWidth}
                    size="small"
                    required
                    InputLabelProps={{ required: true }}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color="inherit" size={18} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                    sx={{
                        "& .MuiInputBase-root": {
                            height: 44,
                            borderRadius: 2,
                        },
                        "& .MuiFormLabel-asterisk": {
                            color: "red",
                        },
                    }}
                />
            )}
            sx={{ width: fullWidth ? "100%" : undefined }}
        />
    );
};

export default ContactSearchDropdown;


// export default ContactSearchDropdown;
// import React, { useState, useEffect } from "react";
// import { TextField, Autocomplete, CircularProgress } from "@mui/material";
// import axios from "axios";

// const path = "http://192.168.1.248:3107";

// const ContactSearchDropdown = ({ label, value, onSelect, companyId, fullWidth, disabled, searchField }) => {
//     const [options, setOptions] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [inputValue, setInputValue] = useState(value || "");

//     // Fetch suggestions based on input
//     const fetchSuggestions = async (searchTerm) => {
//         if (!searchTerm || searchTerm.length < 2) {
//             setOptions([]);
//             return;
//         }
//         setLoading(true);
//         try {
//             const response = await axios.get(`${path}/api/contact-search`, {
//                 params: { search: searchTerm, companyId },
//             });
//             setOptions(response.data.data || []);
//         } catch (error) {
//             console.error(`Error fetching ${searchField} suggestions:`, error);
//             setOptions([]);
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Debounce search to avoid excessive API calls
//     useEffect(() => {
//         const delayDebounceFn = setTimeout(() => {
//             fetchSuggestions(inputValue);
//         }, 300);
//         return () => clearTimeout(delayDebounceFn);
//     }, [inputValue, companyId]);

//     return (
//         <Autocomplete
//             freeSolo
//             options={options}
//             getOptionLabel={(option) =>
//                 typeof option === "string" ? option : option[searchField] || ""
//             }
//             value={value || ""}
//             onChange={(event, newValue) => {
//                 if (typeof newValue === "object" && newValue) {
//                     onSelect(newValue);
//                 } else {
//                     onSelect((prev) => ({
//                         ...prev, // ✅ preserve existing values
//                         [searchField]: newValue || "",
//                     }));
//                 }
//             }}
//             onInputChange={(event, newInputValue) => {
//                 setInputValue(newInputValue);
//                 onSelect((prev) => ({
//                     ...prev, // ✅ preserve existing values
//                     [searchField]: newInputValue || "",
//                 }));
//             }}
//             disabled={disabled}
//             renderInput={(params) => (
//                 <TextField
//                     {...params}
//                     label={label}
//                     fullWidth={fullWidth}
//                     size="small"
//                     required
//                     InputLabelProps={{ required: true }}
//                     InputProps={{
//                         ...params.InputProps,
//                         endAdornment: (
//                             <>
//                                 {loading ? <CircularProgress color="inherit" size={18} /> : null}
//                                 {params.InputProps.endAdornment}
//                             </>
//                         ),
//                     }}
//                     sx={{
//                         "& .MuiInputBase-root": {
//                             height: 44,
//                             borderRadius: 2,
//                         },
//                         "& .MuiFormLabel-asterisk": {
//                             color: "red",
//                         },
//                     }}
//                 />
//             )}
//             sx={{ width: fullWidth ? "100%" : undefined }}
//         />
//     );
// };

// export default ContactSearchDropdown;